import StepTitle from './StepTitle';
import StepDescription from './StepDescription';
import StepButtons from './StepButtons';

const Steps = {
    StepTitle,
    StepDescription,
    StepButtons
}

export default Steps;